/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { L2PriceFeedFake } from "./L2PriceFeedFake";

export class L2PriceFeedFakeFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<L2PriceFeedFake> {
    return super.deploy(overrides || {}) as Promise<L2PriceFeedFake>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): L2PriceFeedFake {
    return super.attach(address) as L2PriceFeedFake;
  }
  connect(signer: Signer): L2PriceFeedFakeFactory {
    return super.connect(signer) as L2PriceFeedFakeFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): L2PriceFeedFake {
    return new Contract(address, _abi, signerOrProvider) as L2PriceFeedFake;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "roundId",
        type: "uint256",
      },
    ],
    name: "PriceFeedDataSet",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "addAggregator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "ambBridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "getLatestTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_numOfRoundBack",
        type: "uint256",
      },
    ],
    name: "getPreviousPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_numOfRoundBack",
        type: "uint256",
      },
    ],
    name: "getPreviousTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "getPriceFeedLength",
    outputs: [
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_interval",
        type: "uint256",
      },
    ],
    name: "getTwapPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_ambBridge",
        type: "address",
      },
      {
        internalType: "address",
        name: "_rootBridge",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_addr",
        type: "address",
      },
    ],
    name: "mockSetMsgSender",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mock_getCurrentTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_number",
        type: "uint256",
      },
    ],
    name: "mock_setBlockNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "mock_setBlockTimestamp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "msgSender",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "priceFeedKeys",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "priceFeedMap",
    outputs: [
      {
        internalType: "bool",
        name: "registered",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
    ],
    name: "removeAggregator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rootBridge",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_priceFeedKey",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_roundId",
        type: "uint256",
      },
    ],
    name: "setLatestData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rootBridge",
        type: "address",
      },
    ],
    name: "setRootBridge",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
